'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmailish = require('./isEmailish');

var _isEmailish2 = _interopRequireDefault(_isEmailish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (link) {
  return (0, _isEmailish2.default)(link) ? /^mailto:/i.test(link) : /^https?:\/\//i.test(link);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/linkhunter/lib/hasProtocol.js
 ** module id = 62
 ** module chunks = 0
 **/